module.exports = __webpack_public_path__ + "static/media/kayak.8f9d97e9.svg";